/**
 * Match hub group for a generic competition (specs/champions-league AC-10.4).
 *
 * Mirrors app/app/worldcup/match/_layout.tsx: the parent competition layout hides its
 * header and tab bar on this branch, and native presents the group as a modal.
 */

import { useMemo } from 'react';
import { Platform } from 'react-native';
import { Stack } from 'expo-router';
import { useTheme } from '../../../../../src/theme/useTheme';
import { getWorldcupStyles } from '../../../../../appStyles/_worldcup.styles';

export default function CompetitionMatchLayout() {
  const theme = useTheme();
  const styles = useMemo(() => getWorldcupStyles(theme, { safeAreaTop: 0 }), [theme]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: styles.stackContentStyle,
        presentation: 'modal',
        animation: Platform.OS === 'web' ? 'fade' : 'slide_from_bottom',
        gestureEnabled: true,
      }}
    />
  );
}
